<template>
  <div class="p-5 b-fs product-card">
    <a :href="link" target="_blank" class="unt crd e-4 h:e-8 rlt -o-h -r-4 w-15 1/1 scale-down-on-hover">
      <div class="w-f h-f b-cl abs .t .s c-s -r-i">
        <div class="h-f w-f rlt -r-i product-card-text">
          <img
            :src="photo"
            class="abs .f -obj-cn -r-i"
          />
          <div class="abs .f -g-t -r-i"></div>
        </div>
        <div class="w-f p-6 c-20-t">
          <div class="o-5">PRODUCT</div>
          <div style="font-size: 24px; font-weight: bold" class="o-9 CASE">
            — {{ name }}
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'productCardWidget',
  props: {
    link: String,
    photo: String,
    name: String
  }
}
</script>

<style>
.product-card-text {
  margin-bottom: -100%;
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.product-card:hover .product-card-text {
  margin-bottom: 0%;
}
</style>
